import Styled from 'styled-components'

export default Styled.div`
    div.Alert{
       display:flex;
       position:fix;
       z-index:99999;
       justify-content:center;
       align-items:center;
       height:100vh;
       width:100%;
    } 
    div.AlertBackground{
        background: #313446;
        width:500px;
        height:500px;
        padding:40px;
        @media only screen and (max-width: 900px) {
        width:300px;
        height:300px;
            }
    }
    div.AlertBackground2{
        background: #313446;
        width:500px;
        height:500px;
        padding:40px;
        @media only screen and (max-width: 900px) {
        width:300px;
        height:200px;
            }
    }
    img {
        width:90px;
        height:90px;
        @media only screen and (max-width: 900px) {
            width:30px;
            height:30px;
        }
    }
    div.successfultitle{
        font-family: 'Poppins';
        font-style: normal;
        margin-top:45px;
        margin-bottom:45px;
        font-weight: 600;
        font-size: 30px;
        line-height: 160%;
        object-fit:contain;
        text-align: center;
        color: rgba(255, 255, 255, 0.8);
        @media only screen and (max-width: 900px) {
            font-size: 12px;
            margin-top:15px;
            margin-bottom:15px;
        }
    }
    img.dash{
        width: 391.52px;
        height: 5.22px;
        object-fit:contain;
        margin-bottom:45px;
        @media only screen and (max-width: 900px) {
            width:200px;
            height:5.22px;
            margin-bottom:25px;
        }
    }
    img.copyicon{
        width:14px;
        height: 14px;
        object-fit:contain;
        @media only screen and (max-width: 900px) {
            width:14px;
            height:14px;
        }
    }
    div.successfuldetails{
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 160%;
        width:440px;
        align-items:start;
        display:flex;
        color: rgba(255, 255, 255, 0.8);
        @media only screen and (max-width: 900px) {
            font-size: 14px;
        }
    }
    div.successfulDetailTitle{
        margin-bottom:27px;
        @media only screen and (max-width: 900px) {
            margin-bottom: 14px;
        }
    }
    div.Link{
        margin-top:50px;
        
    }
    div.successfulspacing{
        margin-right:40%;
        text-align:left;
        @media only screen and (max-width: 900px) {
            margin-right: 13%;
        }
    }
    div.successfulspacing2{ 
       text-align:right;
    }
    div.failedDetails{
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 160%;
        text-align: center;
        color: #FA5050; 
        cursor:pointer;
        @media only screen and (max-width: 900px) {
            font-size:12px;
        }
    }
`
